export default "__VITE_ASSET___MPJ6jhr__"